import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchMonthlyCustomerReportDateRangeDetails } from '@/features/monthly-customer-reports/api'

import { MonthlyCustomerReportDateRangeDetailSearchValidateSchema } from '../-models/monthly-customer-report-date-range-detail-search'

/**
 * 日付範囲明細（請求）(#4829)。参照専用で、親ルートの OWNER ガードを継承する
 */
export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-customer-reports/date-range-detail/'
)({
  validateSearch: (search) =>
    parse(MonthlyCustomerReportDateRangeDetailSearchValidateSchema, search),
  loaderDeps: ({ search }) => search,
  loader: async ({ abortController, params: { tenantKey }, deps }) => {
    const { listSearch } = deps
    return {
      tenantKey,
      detail: await fetchMonthlyCustomerReportDateRangeDetails(
        {
          tenantKey,
          query: {
            customerId: deps.customerId,
            operatingDateFrom: deps.operatingDateFrom,
            operatingDateTo: deps.operatingDateTo,
            // 合計・月次追加請求を遷移元一覧の行と一致させるため、一覧の入力（拠点・荷主の絞り込み）を渡す
            dcIds: listSearch?.dcIds ?? deps.dcIds,
            listCustomerId: listSearch?.customerId,
            page: deps.page,
            take: deps.take
          }
        },
        abortController.signal
      )
    }
  }
})
